// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-2WybxO","content":"content-3Ze321","errorHeading":"errorHeading-1vJ2gL","errorBody":"errorBody-3WpWjA"};